import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import AppShell from "@/components/layout/AppShell";
import MainDashboard from "@/pages/MainDashboard";
import CommandCenter from "@/pages/CommandCenter";
import Crowd from "@/pages/Crowd";
import Incidents from "@/pages/Incidents";
import Predictive from "@/pages/Predictive";
import Parking from "@/pages/Parking";
import VIP from "@/pages/VIP";
import Facilities from "@/pages/Facilities";
import Cameras from "@/pages/Cameras";
import DetectionPage from "@/pages/DetectionPage";
import Placeholder from "@/pages/Placeholder";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route element={<AppShell />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<MainDashboard />} />
              <Route path="/command-center" element={<CommandCenter />} />
              <Route path="/crowd" element={<Crowd />} />
              <Route path="/incidents" element={<Incidents />} />
              <Route path="/predictive" element={<Predictive />} />
              <Route path="/detection" element={<DetectionPage />} />
              <Route path="/cameras" element={<Cameras />} />
              <Route path="/map" element={<Placeholder title="Stadium Map" subtitle="Zone editor · polygons" testid="page-map" />} />
              <Route path="/parking" element={<Parking />} />
              <Route path="/vip" element={<VIP />} />
              <Route path="/facilities" element={<Facilities />} />
              <Route path="/radio" element={<Placeholder title="Dispatch" subtitle="Teams · radio · escalation" testid="page-radio" />} />
              <Route path="/settings" element={<Placeholder title="Settings" subtitle="Users · thresholds · channels" testid="page-settings" />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
